import { Builder } from '@builder.io/react'
import React from 'react'

import './index.css'

interface Feature {
  name: string
}

interface Column {
  imageSource: any
  title: string
  features: Feature[]
  imgAltText: string
}

interface FoodCompareProps {
  backgroundColor: string
  borderColor: string
  textColor: string
  columnOne: Column
  columnTwo: Column
}

const FoodCompare = ({ backgroundColor, borderColor, columnOne, columnTwo, textColor }: FoodCompareProps) => {
  const getDataRows = () => {
    let lengths = columnOne.features.length
    if (columnOne.features.length != columnTwo.features.length) {
      if (columnOne.features.length > columnTwo.features.length) {
        lengths = columnOne.features.length
      } else {
        lengths = columnTwo.features.length
      }
    }

    let elements = []
    for (let i = 0; i < lengths; i++) {
      const ColOneFeature = columnOne?.features[i]
      const ColTwoFeature = columnTwo?.features[i]
      elements.push(
        <div
          key={i}
          className="food-compare-grid-data-row grid grid-cols-2"
          style={{ backgroundColor, borderBottom: `0.1rem solid ${borderColor}`, color: textColor }}
        >
          <div className="p-4 text-center" style={{ borderRight: `0.1rem solid ${borderColor}` }}>
            <p className="text-sm">{ColOneFeature?.name}</p>
          </div>
          <div className="p-4 text-center">
            <p className="text-sm">{ColTwoFeature?.name}</p>
          </div>
        </div>
      )
    }
    elements.push(
      <div className="food-compare-grid-data-row grid grid-cols-2" style={{ backgroundColor }}>
        <div className="p-5" style={{ borderRight: `0.1rem solid ${borderColor}` }} />
        <div className="" />
      </div>
    )

    return elements
  }

  return (
    <div className="w-full md:my-0 md:mx-auto md:w-9/12">
      <div className="grid grid-cols-2" style={{ backgroundColor }} key="left-col">
        <div className="border-solid pt-4 text-center" style={{ borderRight: `0.1rem solid ${borderColor}` }}>
          <img
            className="my-0 mx-auto h-32 w-32 lg:h-48 lg:w-48"
            src={columnOne?.imageSource}
            alt={columnOne?.imgAltText}
            style={{ objectFit: 'cover' }}
          />
          <h5 className="py-4 text-lg" style={{ color: textColor }}>
            {columnOne?.title}
          </h5>
        </div>
        <div className="vs-holder-position absolute hidden md:block" style={{ width: 'fit-content' }}>
          <div
            className="vs-placeholder-content border-solid pt-4 text-center"
            style={{ borderRight: `0.1rem solid ${borderColor}` }}
          >
            <img
              className="my-0 mx-auto h-32 w-32 lg:h-48 lg:w-48"
              src={columnOne?.imageSource}
              alt={columnOne?.imgAltText}
              style={{ objectFit: 'cover' }}
            />
            <div className="pt-4"></div>
          </div>
          {/*           <div className="vs-position" style={{ backgroundColor }}>
            <p className="h5 text-xl font-medium">vs.</p>
          </div> */}
        </div>
        <div className="border-solid pt-4 text-center" key="right-col">
          <img
            className="my-0 mx-auto h-32 w-32 lg:h-48 lg:w-48"
            src={columnTwo?.imageSource}
            alt={columnOne?.imgAltText}
            style={{ objectFit: 'cover' }}
          />
          <h5 className="py-4 text-lg" style={{ color: textColor }}>
            {columnTwo?.title}
          </h5>
        </div>
      </div>
      {getDataRows()}
    </div>
  )
}

export default FoodCompare

Builder.registerComponent(FoodCompare, {
  name: 'FoodCompare',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'borderColor',
      type: 'color',
      defaultValue: 'red'
    },
    {
      name: 'textColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'columnOne',
      type: 'object',
      subFields: [
        { name: 'imageSource', type: 'file', defaultValue: null },
        { name: 'imgAltText', type: 'text', defaultValue: '' },
        { name: 'title', type: 'string', defaultValue: 'Different Dog' },
        {
          name: 'features',
          type: 'list',
          defaultValue: [{ name: 'Good food that tastes good.' }],
          subFields: [{ name: 'name', type: 'string', defaultValue: 'Good food that tastes good.' }]
        }
      ],
      defaultValue: {
        imageSource: 'https://thumbs.dreamstime.com/b/dry-dog-food-bowl-wooden-background-top-view-140127536.jpg',
        imgAltText: '',
        title: 'Different Dog',
        features: [
          {
            name: 'Good food that tastes good.'
          }
        ]
      }
    },
    {
      name: 'columnTwo',
      type: 'object',
      subFields: [
        { name: 'imageSource', type: 'file', defaultValue: null },
        { name: 'imgAltText', type: 'text', defaultValue: '' },
        { name: 'title', type: 'string', defaultValue: 'Different Dog' },
        {
          name: 'features',
          type: 'list',
          defaultValue: [{ name: 'Good food that tastes good.' }],
          subFields: [{ name: 'name', type: 'string', defaultValue: 'Good food that tastes good.' }]
        }
      ],
      defaultValue: {
        imageSource: 'https://troyangrignon.com/content/images/2020/07/Screen-Shot-2020-07-01-at-2.50.40-PM.png',
        imgAltText: '',
        title: 'Other Dog Food',
        features: [
          {
            name: 'Good food that tastes not good.'
          }
        ]
      }
    }
  ]
})
